/* @preserve
 * https://github.com/Elkfox/Ajaxinate
 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
 * MIT License (do not remove above copyright!)
 */

/* Configurable options;
 *
 * method: scroll or click
 * container: selector of repeating content
 * pagination: selector of pagination container
 * offset: number of pixels before the bottom to start loading more on scroll
 * loadingText: 'Loading', The text shown during when appending new content
 * callback: null, callback function after new content is appended
 */

(function () {
  "use strict";

  function Ajaxinate(config) {
    var settings = config || {};
    var defaults = {
      method: "scroll",
      container: "#AjaxinateContainer",
      pagination: "#AjaxinatePagination",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    };

    // Merge custom configs with defaults
    this.settings = Object.assign(defaults, settings);

    // Selectors
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);

    // Bind functions
    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
    this.removeClickListener = this.removeClickListener.bind(this);
    this.removeScrollListener = this.removeScrollListener.bind(this);
    this.removePaginationElement = this.removePaginationElement.bind(this);
    this.destroy = this.destroy.bind(this);

    this.initialize();
  }

  Ajaxinate.prototype.initialize = function initialize() {
    if (!this.containerElement) {
      return;
    }

    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    };

    initializers[this.settings.method]();
  };

  Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
    if (!this.paginationElement) {
      return;
    }

    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
    // Initial check
    this.checkIfPaginationInView();
  };

  Ajaxinate.prototype.addClickListener = function addClickListener() {
    if (!this.paginationElement) {
      return;
    }

    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (
      typeof this.nextPageLinkElement !== "undefined" &&
      this.nextPageLinkElement !== null
    ) {
      this.nextPageLinkElement.addEventListener(
        "click",
        this.preventMultipleClicks
      );
    }
  };

  Ajaxinate.prototype.preventMultipleClicks = function preventMultipleClicks(
    event
  ) {
    event.preventDefault();

    if (!this.clickActive) {
      return;
    }

    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  };

  Ajaxinate.prototype.checkIfPaginationInView =
    function checkIfPaginationInView() {
      if (!this.paginationElement) {
        return;
      }

      var top =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset;
      var bottom =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset;

      // Also trigger when the user has scrolled near the bottom of the document
      var scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      var nearBottom =
        window.innerHeight + scrollTop >=
        document.documentElement.scrollHeight - this.settings.offset;

      if ((top <= window.innerHeight && bottom >= 0) || nearBottom) {
        this.nextPageLinkElement = this.paginationElement
          ? this.paginationElement.querySelector("a")
          : null;

        // Only remove listeners and load if there's an actual next link
        if (this.nextPageLinkElement) {
          this.removeScrollListener();
          this.nextPageLinkElement.innerText = this.settings.loadingText;
          this.nextPageUrl = this.nextPageLinkElement.href;
          this.loadMore();
        }
      }
    };

  Ajaxinate.prototype.loadMore = function loadMore() {
    var self = this;

    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = function success() {
      // Check readyState and status first
      if (self.request.readyState !== 4) {
        return;
      }

      if (self.request.status !== 200) {
        console.error(
          "Ajaxinate: Request failed with status",
          self.request.status
        );
        return;
      }

      // Get response document (responseType: 'document' uses response, not responseXML)
      var responseDoc = self.request.response || self.request.responseXML;

      // Fallback: if document parsing failed, try parsing as text
      if (!responseDoc || !responseDoc.querySelector) {
        console.warn("Ajaxinate: Document parsing failed, trying text parsing");
        var responseText = self.request.responseText;
        if (responseText) {
          var parser = new DOMParser();
          responseDoc = parser.parseFromString(responseText, "text/html");
        }
      }

      if (!responseDoc || !responseDoc.querySelector) {
        console.error("Ajaxinate: No valid response document available");
        return;
      }

      // Find container - try multiple selectors for Shopify compatibility
      var newContainer =
        responseDoc.querySelector(self.settings.container) ||
        responseDoc.querySelector("#AjaxinateContainer") ||
        responseDoc.querySelector("#collection") ||
        responseDoc.querySelector("ul.l4cl");

      // Debug: Log container finding
      if (!newContainer) {
        console.warn(
          "Ajaxinate: Container not found, trying alternative methods"
        );
        // Try to find by class
        var allContainers = responseDoc.querySelectorAll(
          "ul.l4cl, ul#collection, ul#AjaxinateContainer"
        );
        if (allContainers.length > 0) {
          newContainer = allContainers[0];
          console.log(
            "Ajaxinate: Found container by alternative method",
            newContainer
          );
        }
      }

      // Find pagination
      var newPagination =
        responseDoc.querySelector(self.settings.pagination) ||
        responseDoc.querySelector("#AjaxinatePagination");

      if (newContainer) {
        // Clone and append child elements directly (more reliable than innerHTML)
        var children = Array.from(newContainer.children);
        console.log(
          "Ajaxinate: Found container with",
          children.length,
          "children"
        );

        if (children.length > 0) {
          children.forEach(function (child) {
            var clonedChild = child.cloneNode(true);
            self.containerElement.appendChild(clonedChild);
          });
          console.log(
            "Ajaxinate: Appended",
            children.length,
            "items to container"
          );
        } else {
          // Fallback to innerHTML if no direct children found
          console.warn(
            "Ajaxinate: No direct children found, using innerHTML fallback"
          );
          var innerHTML = newContainer.innerHTML;
          if (innerHTML && innerHTML.trim().length > 0) {
            self.containerElement.insertAdjacentHTML("beforeend", innerHTML);
            console.log("Ajaxinate: Appended content via innerHTML");
          } else {
            console.error("Ajaxinate: Container is empty", newContainer);
          }
        }
      } else {
        console.error("Ajaxinate: Container not found in response", {
          container: self.settings.container,
          responseDoc: responseDoc,
          responseHTML: responseDoc.documentElement
            ? responseDoc.documentElement.outerHTML.substring(0, 500)
            : "No documentElement",
        });
      }

      // Update pagination info if exists
      var newPaginationInfo = responseDoc.getElementById
        ? responseDoc.getElementById("load-more-info")
        : responseDoc.querySelector("#load-more-info");
      var currentPaginationInfo = document.getElementById("load-more-info");
      if (
        newPaginationInfo &&
        currentPaginationInfo &&
        currentPaginationInfo.parentNode
      ) {
        currentPaginationInfo.parentNode.replaceChild(
          newPaginationInfo.cloneNode(true),
          currentPaginationInfo
        );
      }

      // If no pagination (last page), remove the pagination element, otherwise update it
      if (
        typeof newPagination === "undefined" ||
        !newPagination ||
        !newPagination.querySelector("a")
      ) {
        self.removePaginationElement();
      } else {
        self.paginationElement.innerHTML = newPagination.innerHTML;
      }

      // Shopify-specific callbacks — always run after appending new items
      if (typeof window.ratings === "function") {
        window.ratings();
      }
      if (typeof semanticInputAsync === "function") {
        semanticInputAsync();
      }
      if (typeof schemeTooltipAsync === "function") {
        schemeTooltipAsync();
      }
      if (typeof popupsAsync === "function") {
        popupsAsync();
      }
      if (typeof listScrollableAsync === "function") {
        listScrollableAsync();
      }
      if (typeof window.sals === "function") {
        window.sals();
      }
      if (typeof window.checkLimit === "function") {
        window.checkLimit();
      }
      if (typeof ajaxCart !== "undefined" && ajaxCart.init) {
        ajaxCart.init();
      }
      if (typeof quickShop !== "undefined" && quickShop.init) {
        quickShop.init();
      }
      if (typeof saveLoadMoreAnchor === "function") {
        saveLoadMoreAnchor();
      }

      // Custom callback
      if (
        self.settings.callback &&
        typeof self.settings.callback === "function"
      ) {
        self.settings.callback(responseDoc);
      }

      // Reinitialize (will only add listeners if pagination exists)
      self.initialize();
    };

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  };

  Ajaxinate.prototype.removeClickListener = function removeClickListener() {
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener(
        "click",
        this.preventMultipleClicks
      );
    }
  };

  Ajaxinate.prototype.removePaginationElement =
    function removePaginationElement() {
      this.paginationElement.innerHTML = "";
      this.destroy();
    };

  Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener(
      "orientationchange",
      this.checkIfPaginationInView
    );
  };

  Ajaxinate.prototype.destroy = function destroy() {
    var destroyers = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    };

    destroyers[this.settings.method]();
    return this;
  };

  // Initialize Ajaxinate when DOM is ready
  function initAjaxinate() {
    // Check if infinite scroll is enabled
    var paginationType = document.querySelector(
      '[data-pagination-type="infinite"]'
    );
    if (!paginationType) {
      return;
    }

    // Initialize with scroll method and offset
    window.ajaxinateInstance = new Ajaxinate({
      method: "scroll",
      container: "#AjaxinateContainer",
      pagination: "#AjaxinatePagination",
      offset: 300, // Start loading 300px before pagination is visible
      loadingText: "Loading...",
      callback: function (responseXML) {
        // Additional callback if needed
        var event = new CustomEvent("ajaxinate:loaded", {
          detail: { responseXML: responseXML },
        });
        document.dispatchEvent(event);
      },
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAjaxinate);
  } else {
    initAjaxinate();
  }

  // Reinitialize after AJAX navigation (for theme editor compatibility)
  document.addEventListener("shopify:section:load", function () {
    if (window.ajaxinateInstance) {
      window.ajaxinateInstance.destroy();
    }
    setTimeout(initAjaxinate, 100);
  });

  // Export for global access
  window.Ajaxinate = Ajaxinate;
})();
